// authSessionManager.js
import { authActions } from 'context/AuthContext'; // your export
import { decodeJWT, setSession } from './jwt';
import axios from '../utils/axios';

let expTime = null;           // ms
let timeoutTime = null;       // ms
let intervalId = null;
let isRefreshing = false;
let lastActivityAt = Date.now(); // ms

const IDLE_WINDOW = 60 * 60 * 1000;       
const REFRESH_THRESHOLD_SECOND = 30 * 60 ; // refresh if < 30m to exp
const ACTIVE_WINDOW = 60 * 1000;         // consider "active" if used in last 30s

// const IDLE_WINDOW = 60 * 1000;       
// const REFRESH_THRESHOLD_SECOND = 30 * 1000; // refresh if < 30m to exp
// const ACTIVE_WINDOW = 10 * 1000;          // consider "active" if used in last 30s

export function startAuthSessionWatcher(accessToken) {
  
  const payload = decodeJWT(accessToken);  // { exp, ... }
  if (!payload?.exp) return; // safety
  // console.log("startAuthSessionWatcher",payload);

  expTime = payload.exp * 1000; // seconds -> ms
  timeoutTime = Date.now() + IDLE_WINDOW;
  lastActivityAt = Date.now();

  if (intervalId) clearInterval(intervalId);

  intervalId = setInterval(() => {
    const now = Date.now() // + IDLE_WINDOW - 20000;
    const timeToExp = (expTime - now) / 1000;
    const inactivityDuration = now - lastActivityAt;
    const isUserActive = inactivityDuration < ACTIVE_WINDOW;
    const timeToIdleLogout = Math.floor(timeoutTime - now);

    // console.log({
    //   timeToExpire_sec: Math.floor(timeToExp / 1000),
    //   timeToIdleLogout_sec: timeToIdleLogout,
    //   inactivity_sec: Math.floor(inactivityDuration / 1000),
    //   isUserActive,
    //   isRefreshing
    // });
    
    // 1. Idle logout
    if ( timeToIdleLogout < 1 ) {
      console.log('Idle timeout -> logout' , timeToExp);
      stopAuthSessionWatcher();
      if (authActions.logout) authActions.logout();
      return;
    }

    // 2. Refresh if token is close to expiring AND user is "recently active"
    // console.log(timeToExp , REFRESH_THRESHOLD_SECOND);
    
    if (timeToExp < REFRESH_THRESHOLD_SECOND && !isRefreshing) {
      refreshToken();
    }
  }, 10_000); // every 10s
}

export function bumpSession() {
  // console.log("bumpSession");
  
  // called on any user activity
  if (!expTime) return;
  const now = Date.now();
  lastActivityAt = now;
  timeoutTime = now + IDLE_WINDOW; // sliding idle window
}

export function stopAuthSessionWatcher() {
  if (intervalId) clearInterval(intervalId);
  intervalId = null;
  expTime = null;
  timeoutTime = null;
  lastActivityAt = Date.now();
}

async function refreshToken() {
  try {
    isRefreshing = true;
    // console.log("refreshToken");
    
    // Example: you must implement this endpoint
    const resp = await axios.post('/auth/refresh_token')?.then(resp => resp?.data);
    // console.log("refreshToken",resp);
    if(resp?.token){
      const accessToken = resp.token;
      
      if (!accessToken) throw new Error('No accessToken on refresh');
  
      setSession(accessToken);
      const payload = decodeJWT(accessToken);
      expTime = (parseInt(payload.exp,10 )* 1000 * 10);
  
      timeoutTime = Date.now() + IDLE_WINDOW;
  
    }else{
      // console.log("refreshToken resp",resp);
    }
  } catch (err) {
    console.error('refreshToken failed', err);
    // if (authActions.logout) authActions.logout();
  } finally {
    isRefreshing = false;
  }
}
